<!-- eslint-disable -->
<template>
    <div class="page-content">
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">A. MOBILE BANKING - BANK MUAMALAT (BMI)</h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Bayar dan Top Up</strong></li>
                  <li>Pilih menu <strong>Virtual Account</strong></li>
                  <li>Isi nomor Virtual Account dengan 16 digit nomor Virtual Account BMI siswa : <strong>{{ '8571680000'+this.dataSiswa.nis }}</strong></li>
                  <li>Tagihan yang muncul sudah otomatis ditambahkan biaya admin bank sebesar Rp. 3.000 : <strong>Total Tagihan Rp. {{ $filters.currencyUSD(jumlahTagihan) }}</strong></li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">B.	ATM - BANK MUAMALAT (BMI)</h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Pembayaran</strong></li>
                  <li>Pilih Pembayaran <strong>Virtual Account</strong></li>
                  <li>Isi nomor Virtual Account dengan 16 digit nomor Virtual Account BMI siswa : <strong>{{ '8571680000'+this.dataSiswa.nis }}</strong></li>
                  <li>Tagihan yang muncul sudah otomatis ditambahkan biaya admin bank sebesar Rp. 3.000 : <strong>Total Tagihan Rp. {{ $filters.currencyUSD(jumlahTagihan) }}</strong></li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: "PetunjukBMI",
  props: {
    dataSiswa: {},
    jumlahTagihan: 0,
  }
};
</script>